import { Col, Row } from 'antd'
import ReportFooter from '../ReportFooter/ReportFooter'
import './ReportSignatures.style.less'

interface Props {
  data: any
}

function ReportSignatures(props: Props) {
  return (
    <div className="report-page-break">
      <div className="report-signatures-container report-page-break">
        <p className="title">Signatures</p>
        <Row
          gutter={[16, 16]}
          style={{ padding: '0 15px' }}
          className="report-page-break"
          justify={'space-between'}
        >
          {props?.data?.map((item, key) => {
            return (
              <Col
                className="image-container report-page-break"
                key={key}
                span={12}
              >
                <img src={item.media} />
                <p>{item.name}</p>
              </Col>
            )
          })}
        </Row>
      </div>
      <ReportFooter />
    </div>
  )
}

export default ReportSignatures
